import {FlowBasicState, FlowModuleEvents, LogicEvents, UIDisableReason, IEventManagerWithAsync, GlobalEventsMap} from '@gongxigames/framework/slot';
import {Action} from 'com/gongxigames/math/core/game/enums/Action';
import {GameLogic} from 'src/server/GameLogic';
import {GameFlowModuleEvents} from 'src/win/GameFlowModuleEvents';
import {RandomWildEvents} from 'src/randomWild/RandomWildEvents';
import {GamePickBonusEvents} from 'src/pickBonus/GamePickBonusEvents';

export class GameFlowBasicState extends FlowBasicState {
    protected setupEvents(): void {
        super.setupEvents();
        this.setEventHandler(LogicEvents.BUY_RESPONSE, this.onBuyResponse.bind(this));
        this.setEventHandler(GamePickBonusEvents.PICK_BONUS_FINISHED, this.onPickBonusFinished.bind(this));
    }

    protected startCoinFlightFeature(): void {
    }

    protected onAllReelsStopped(): void {
        const logic = (this.module.logic as GameLogic);

        if (logic.isCoinFlightFeature(this.module.getRubyCoinSymbolId!)) {
            this.emit(FlowModuleEvents.START_COIN_FLIGHT_FEATURE);
        }

        if (logic.isRandomWildFeature()) {
            this.setupFeaturesSequence();
        } else {
            super.onAllReelsStopped();
        }
    }

    protected onBuyResponse(index: number): void {
        this.emit(FlowModuleEvents.BLOCKING_FLOW);
        this.emit(FlowModuleEvents.START_PICK_BONUS);
        (this._eventManager as IEventManagerWithAsync<GlobalEventsMap>).emit('General.UI.DISABLE', UIDisableReason.TRIGGERING_FEATURE);
    }

    protected onPickBonusFinished(): void {
        const fsWon: number = this.module.logic.getFreeGamesCount();

        this.emit(FlowModuleEvents.FREESPINS_WIN, fsWon);
    }

    protected onBuyButtonClicked(): void {
    }

    protected setupFeaturesSequence(): void {
        this.emit(GameFlowModuleEvents.START_RANDOM_WILD_FEATURE);
        this.addCallbackToWaitingLIst(RandomWildEvents.RANDOM_WILD_FEATURE_FINISHED, this.onDecideNextStep.bind(this));
    }

    protected onDecideNextStep(): void {
        this.clearEventsQueue();
        this.addCallbackToWaitingLIst(FlowModuleEvents.CAN_SPIN, this.emitRoundEnded.bind(this));
        this.addCallbackToWaitingLIst(FlowModuleEvents.FREESPINS_WIN, this.emitRoundEnded.bind(this));
        this.addCallbackToWaitingLIst(FlowModuleEvents.RESPIN_WIN, this.emitRoundEnded.bind(this));
        this.addCallbackToWaitingLIst(FlowModuleEvents.SELECT_BONUS_START, this.emitRoundEnded.bind(this));
        this.addCallbackToWaitingLIst(FlowModuleEvents.BONUS_GAME_WON, this.emitRoundEnded.bind(this));
        switch (this.module.logic.nextAction) {
            case Action.SPIN: {
                this.setupLinesWinMainGameSequence();
                break;
            }
            case Action.SELECT: {
                this.setupSelectBonusSequence();
                break;
            }
            case Action.FREESPIN: {
                // we have won free spins
                if (this.module.logic.previousAction !== Action.FREESPIN) {
                    this.setupWinBeforeFreeGames();
                }
                break;
            }
            case Action.PICK: {
                this.emit(FlowModuleEvents.BONUS_GAME_WON);
                this.setupPickBonusSequence();
                break;
            }
            case Action.RESPIN: {
                this.setupRespin();
                break;
            }
            default:
                break;
        }
    }

    protected setupFSTriggerWithNoWin(): void {
        if (this.module.resourceManager.isResourcesLoaded) {
            const fsWon: number = this.module.logic.getFreeGamesCount();

            this.emit(FlowModuleEvents.FREESPINS_WIN, fsWon);
        } else {
            this.addToWaitingForResources(this.setupFSTriggerWithNoWin);
        }
    }
}
